import { render, staticRenderFns } from "./reparation-technique.vue?vue&type=template&id=61594ffe&scoped=true"
import script from "./reparation-technique.vue?vue&type=script&lang=js"
export * from "./reparation-technique.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61594ffe",
  null
  
)

export default component.exports